import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Register service worker for PWA functionality
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      console.log('PWA Debug - Registering service worker');
      
      // Check if we're in production or development
      const isProd = import.meta.env.PROD;
      console.log('PWA Debug - Is production mode:', isProd);
      console.log('PWA Debug - Browser supports installation:', 'onbeforeinstallprompt' in window);
      
      const scope = '/';
      
      if (isProd) {
        // Production registration
        const registration = await navigator.serviceWorker.register('/sw.js', { scope });
        console.log('PWA Debug - Service worker registered successfully:', registration.scope);
        
        // Add update logic
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            console.log('PWA Debug - New service worker installing');
            newWorker.addEventListener('statechange', () => {
              console.log('PWA Debug - Service worker state changed to:', newWorker.state);
            });
          }
        });
      } else {
        // Dev mode registration (uses VitePWA dev options)
        console.log('PWA Debug - Running in development mode, using VitePWA dev service worker');
        const devRegistration = await navigator.serviceWorker.register('/dev-sw.js', { scope });
        console.log('PWA Debug - Dev service worker registered:', devRegistration.scope);
      }
      
      // Add event listener for controllerchange events
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('PWA Debug - Service worker controller changed');
      });
      
      // Make sure service worker is available before page load (don't wait for load event)
      if (navigator.serviceWorker.controller) {
        console.log('PWA Debug - Page is already controlled by a service worker');
      } else {
        console.log('PWA Debug - Page is not yet controlled by a service worker');
      }
      
    } catch (error) {
      console.error('PWA Debug - Service worker registration failed:', error);
    }
  } else {
    console.warn('PWA Debug - Service workers are not supported in this browser');
  }
};

// Execute the service worker registration
registerServiceWorker().catch(error => {
  console.error('PWA Debug - Error during service worker registration setup:', error);
});

// Application rendering
const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error('Root element not found');
}
